import { CATEGORY_ACTIONS as TYPES } from "../chatbotActions/chatbotActionTypes";
import { apicall } from "../../../services/api";
import { toast } from "react-hot-toast";

const BASE_URL = "chatbot/category";

// Fetch all categories
export const fetchCategories = (update=false) => async (dispatch,getState) => {
  dispatch({ type: TYPES.FETCH_REQUEST });
  if (update) {
    if (getState().categoryReducer?.categories?.data?.length > 0) {
      dispatch({ type: TYPES.FETCH_SUCCESS, payload: getState().categoryReducer?.categories });
      return;
    }
  }

  try {
    const res = await apicall(BASE_URL,"get",{},{},"v3");
    dispatch({ type: TYPES.FETCH_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_FAILURE, payload: err.message });
  }
};

// Fetch category by ID
export const fetchCategoryById = (id) => async (dispatch) => {
  dispatch({ type: TYPES.FETCH_BY_ID_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`,"get",{},{},"v3");
    dispatch({ type: TYPES.FETCH_BY_ID_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_BY_ID_FAILURE, payload: err.message });
  }
};

// Add category
export const addCategory = (data) => async (dispatch) => {
  dispatch({ type: TYPES.ADD_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/`,"post",data,{},"v3");
    toast.success(res.data.message || "Category added successfully");
    dispatch(fetchCategories());
    dispatch({ type: TYPES.ADD_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.ADD_FAILURE, payload: err.message });
  }
};

// Update category
export const updateCategory = (id, data) => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`,"patch",data,{},"v3");
    
    toast.success(res.data.message || "Category updated successfully");
    dispatch(fetchCategories());
    dispatch({ type: TYPES.UPDATE_SUCCESS, payload: res.data });
  } catch (err) {
    toast.error(err.message || "Failed to update category");
    dispatch({ type: TYPES.UPDATE_FAILURE, payload: err.message });
  }
};

// Delete category
export const deleteCategory = (id) => async (dispatch) => {
  dispatch({ type: TYPES.DELETE_REQUEST });
  try {
    await apicall(`${BASE_URL}/${id}`,"delete",{},{},"v3");
    toast.success("Category deleted successfully");
    dispatch(fetchCategories());
    dispatch({ type: TYPES.DELETE_SUCCESS, payload: id });
  } catch (err) {
    dispatch({ type: TYPES.DELETE_FAILURE, payload: err.message });
  }
};
